<div class="d-flex flex-column animated fadeInDown" style="align-items: center">
    <h2 class="logo-name">Brewers City Dock</h2>
    <div style="margin-top: 35px">client version: {{ appInfo.clientVersion }}</div>
    <div style="margin-top: 5px">service version: {{ appInfo.serviceVersion }}</div>
</div>


<button style="margin-top: 40px; margin-left: 20px; max-width: 100px" (click)="logout()">Log Out</button>
